import {
  Breakpoints,
  Carousel,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import { type FC } from 'react';

import {
  getOfferingPackageCoachingTimeLabel,
  getOfferingPackagePriceLabel,
  getPackageListingPageUrl,
} from '../../utils/package';
import { OfferingPackageImage } from '../package/OfferingPackageImage';

import { type CoachCardPackageCarouselOfferingPackageFragment } from './__generated-gql-types__/CoachCardPackageCarousel.generated';

interface CoachCardPackageCarouselProps {
  packages: CoachCardPackageCarouselOfferingPackageFragment[];
  coachSlug: string;
  className?: string;
}

export const CoachCardPackageCarousel: FC<CoachCardPackageCarouselProps> = ({
  packages,
  coachSlug,
  className = '',
}) => {
  const isMd = useMediaQuery(Breakpoints.MD);

  return (
    <div className={`flex w-full overflow-hidden ${className}`}>
      <Carousel
        swiperProps={{
          slidesPerGroupAuto: false,
          slidesPerView: isMd ? 2.25 : 1.15,
        }}
        items={packages.map((p) => {
          const offeringPackageCoachingTimeLabel =
            getOfferingPackageCoachingTimeLabel(p.prices);

          return (
            <Link
              key={p.id}
              className="mr-3 flex w-full items-center space-x-3 rounded-sm border border-leland-gray-stroke bg-white p-4"
              href={getPackageListingPageUrl({
                coachSlug,
                packageSlug: p.slug,
                packageId: p.id,
              })}
              target="_blank"
              rel="noopener noreferrer"
            >
              <OfferingPackageImage
                containerClassName="w-18 shrink-0"
                sizes={{ dflt: '70px' }}
                name={p.name}
                imageLink={p.imageLink}
              />
              <div className="flex flex-col justify-center">
                <p className="line-clamp-1 text-lg leading-4 text-leland-gray-dark">
                  {p.name}
                </p>
                <p className="mt-1 line-clamp-1 leading-5 text-leland-gray-light">
                  {getOfferingPackagePriceLabel(p.prices)}
                  {offeringPackageCoachingTimeLabel ? (
                    <>
                      <span className="mx-2 my-1 inline-flex size-0.5 rounded-full bg-leland-gray-light" />
                      <span>{offeringPackageCoachingTimeLabel}</span>
                    </>
                  ) : null}
                </p>
              </div>
            </Link>
          );
        })}
      />
    </div>
  );
};
